/// <amd-module name="Wit/Clients/ConnectedService/Client/RestClient/ConnectedService" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\wit\vss-work-web\clients\connectedservice\clientgeneratorconfigs\connectedservice.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ConnectedService from "Wit/Clients/ConnectedService/Types/Contracts/ConnectedService";

export interface IConnectedServiceRestClient extends IVssRestClient {
    /**
     * @param authRequest - 
     * @param project - Project ID or project name
     * @param providerId - 
     * @param configurationId - 
     * @param scope - 
     * @param callbackQueryParams - 
     * @param endpointType - 
     */
    createAuthRequest(authRequest: ConnectedService.AuthRequest, project: string, providerId: string, configurationId?: string, scope?: string, callbackQueryParams?: string, endpointType?: string): Promise<ConnectedService.AuthRequest>;
    /**
     * @param project - Project ID or project name
     * @param providerId - 
     * @param oauthTokenKey - 
     */
    getAppInstallations(project: string, providerId: string, oauthTokenKey: string): Promise<ConnectedService.Installation[]>;
}

class ConnectedServiceRestClient extends RestClientBase implements IConnectedServiceRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param authRequest - 
     * @param project - Project ID or project name
     * @param providerId - 
     * @param configurationId - 
     * @param scope - 
     * @param callbackQueryParams - 
     * @param endpointType - 
     */
    public async createAuthRequest(
        authRequest: ConnectedService.AuthRequest,
        project: string,
        providerId: string,
        configurationId?: string,
        scope?: string,
        callbackQueryParams?: string,
        endpointType?: string
        ): Promise<ConnectedService.AuthRequest> {

        const queryValues: any = {
            configurationId: configurationId,
            scope: scope,
            callbackQueryParams: callbackQueryParams,
            endpointType: endpointType
        };

        return this.beginRequest<ConnectedService.AuthRequest>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/connectedService/providers/{providerId}/authRequests",
            routeValues: {
                project: project,
                providerId: providerId
            },
            queryParams: queryValues,
            body: authRequest
        });
    }

    /**
     * @param project - Project ID or project name
     * @param providerId - 
     * @param oauthTokenKey - 
     */
    public async getAppInstallations(
        project: string,
        providerId: string,
        oauthTokenKey: string
        ): Promise<ConnectedService.Installation[]> {

        const queryValues: any = {
            oauthTokenKey: oauthTokenKey
        };

        return this.beginRequest<ConnectedService.Installation[]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/connectedService/providers/{providerId}/authRequests",
            routeValues: {
                project: project,
                providerId: providerId
            },
            queryParams: queryValues
        });
    }

}

export const ConnectedServiceClientName = "ConnectedServiceForWit.IConnectedServiceRestClient";

export function getConnectedServiceClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IConnectedServiceRestClient {
    return pageContext.getRestClient<IConnectedServiceRestClient>(ConnectedServiceClientName, options);
}

RestClients.add(ConnectedServiceClientName, { 
    factory: ConnectedServiceRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
